module.exports = __webpack_public_path__ + "static/media/customer4.3f58ff21.svg";